<div class="{ui}menu" part="menu">
  {#each item in items}
    <menu-item
      active={isValueActive value item}
      href={item.href}
      data-value={item.value}
      exportparts="item"
    >
      {#if item.icon}
        <ui-icon part="item-icon" icon={item.icon}></ui-icon>
      {/if}
      <span part="item-label" class="label">{item.label}</span>
      {#if item.badge}
        <ui-label part="item-badge" outline badge>
          {item.badge}
        </ui-label>
      {/if}
    </menu-item>
  {else}
    {>slot}
  {/each}
</div>
